// extracted by mini-css-extract-plugin
module.exports = {"Title":"FooterInfoSection_Title__1ZnDu","DescriptionWrapper":"FooterInfoSection_DescriptionWrapper__2xNYR","Description":"FooterInfoSection_Description__2Pag1"};